export default {
    root: 'https://www.ncu.edu.jm/manage/wp-json/wp/v2/',
    rootUrl: 'https://www.cmsapi.ncu.edu.jm:4775/degree',
    newRootUrl: 'https://manage.ncu.edu.jm/wp-json/data/',
    strapiApi: 'http://cmsapi.ncu.edu.jm/',
    undergradDegrees: [],
    extensionDegrees: [],
    gradDegrees: [],
    viewDegree: [],
    viewGradDegree: [],
    GradPrograms: [],
    programmeResults: [],
    SingleProgramResult: []
}
